var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 102,
    viewBox: "0 0 106 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4418 92.4492C76.8925 92.4492 96.8153 72.6088 96.8153 48.2404C96.733 23.7897 76.8925 3.94922 52.4418 3.94922C27.9088 3.94922 8.06836 23.7897 8.06836 48.1581C8.06836 72.6088 27.9088 92.4492 52.4418 92.4492Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9075_10864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2968 28.0503V82.5788C84.2968 86.5519 81.1457 89.7031 77.1725 89.7031H28.1243C24.1511 89.7031 21 86.5519 21 82.5788V11.1985C21 7.22536 24.1511 4.07422 28.1243 4.07422H60.4578C62.2388 4.07422 63.8829 4.75925 65.116 5.99231L82.3787 23.2551C83.6118 24.6251 84.2968 26.2692 84.2968 28.0503Z",
    fill: "url(#paint0_linear_9075_10864)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9075_10864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.707 4.91797V19.9374C63.707 22.8431 66.1677 25.1677 68.9639 25.1677H83.6569C83.34 24.4862 82.9103 23.8447 82.3787 23.254L65.1159 5.99128C64.6913 5.56665 64.2179 5.20702 63.707 4.91797Z",
    fill: "#D5DDEA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.164 74.8571H30.739C30.3127 74.8571 29.9717 74.4039 29.9717 73.8602C29.9717 73.3164 30.3127 72.8633 30.739 72.8633H42.164C42.5903 72.8633 42.9314 73.3164 42.9314 73.8602C42.9314 74.4946 42.5903 74.8571 42.164 74.8571Z",
    fill: "#D5DDEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7752 19.029H31.0814C30.4839 19.029 29.9717 18.5688 29.9717 18.0321C29.9717 17.4953 30.4839 17.0352 31.0814 17.0352H56.7752C57.3727 17.0352 57.8849 17.4953 57.8849 18.0321C57.8849 18.5688 57.3727 19.029 56.7752 19.029Z",
    fill: "#D6DCE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9164 25.0133H31.0746C30.4807 25.0133 29.9717 24.5532 29.9717 24.0164C29.9717 23.4796 30.4807 23.0195 31.0746 23.0195H40.8315C41.4254 23.0195 41.9345 23.4796 41.9345 24.0164C41.9345 24.5532 41.4254 25.0133 40.9164 25.0133Z",
    fill: "#D6DCE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0239 59.9023H45.0632H41.761H31.7741C31.3714 59.9023 30.9688 60.3177 30.9688 60.8992C30.9688 61.3977 31.2909 61.8961 31.7741 61.8961H41.761H45.0632H75.0239C75.4266 61.8961 75.8293 61.4808 75.8293 60.8992C75.7487 60.3177 75.4266 59.9023 75.0239 59.9023Z",
    fill: "#D6DCE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0224 52.9258H63.888H60.0958H31.7756C31.3722 52.9258 30.9688 53.3412 30.9688 53.9227C30.9688 54.4211 31.2915 54.9196 31.7756 54.9196H60.0958H63.888H75.0224C75.4258 54.9196 75.8293 54.5042 75.8293 53.9227C75.7486 53.3412 75.4258 52.9258 75.0224 52.9258Z",
    fill: "#D6DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0955 45.9492H72.202H69.3084H31.7725C31.3706 45.9492 30.9688 46.3646 30.9688 46.9461C30.9688 47.4446 31.2903 47.943 31.7725 47.943H69.3084H72.5235H75.0151C75.417 47.943 75.8189 47.5276 75.8189 46.9461C75.8993 46.4477 75.4974 45.9492 75.0955 45.9492Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0324 38.9609H65.7097H63.399H31.7656C31.3672 38.9609 30.9688 39.3763 30.9688 39.9578C30.9688 40.4563 31.2875 40.9547 31.7656 40.9547H63.399H65.7097H74.9528C75.5105 40.9547 75.8293 40.5394 75.8293 39.9578C75.8293 39.4594 75.5105 38.9609 75.0324 38.9609Z",
    fill: "#D6DCE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8851 32.7624C99.7493 32.7624 101.26 31.2512 101.26 29.3871C101.26 27.5229 99.7493 26.0117 97.8851 26.0117C96.021 26.0117 94.5098 27.5229 94.5098 29.3871C94.5098 31.2512 96.021 32.7624 97.8851 32.7624Z",
    fill: "#EAEEF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.825 19.5907C104.098 19.5907 105.13 18.5587 105.13 17.2856C105.13 16.0125 104.098 14.9805 102.825 14.9805C101.552 14.9805 100.52 16.0125 100.52 17.2856C100.52 18.5587 101.552 19.5907 102.825 19.5907Z",
    fill: "#EAEEF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28093 77.8783C6.64522 77.8783 8.56186 75.9616 8.56186 73.5973C8.56186 71.233 6.64522 69.3164 4.28093 69.3164C1.91664 69.3164 0 71.233 0 73.5973C0 75.9616 1.91664 77.8783 4.28093 77.8783Z",
    fill: "#EAEEF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3257 92.6007C88.8945 92.6007 96.6515 84.8437 96.6515 75.275C96.6515 65.7062 88.8945 57.9492 79.3257 57.9492C69.757 57.9492 62 65.7062 62 75.275C62 84.8437 69.757 92.6007 79.3257 92.6007Z",
    fill: "#EB4C43"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1611 70.7501L75.6758 79.2353M84.1611 79.2353L75.6758 70.75",
    stroke: "white",
    strokeWidth: 2.48276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9075_10864",
    x: 12.8498,
    y: -0.000898838,
    width: 79.5973,
    height: 101.929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.07512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07512
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9075_10864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9075_10864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9075_10864",
    x: 55.5568,
    y: 0.842851,
    width: 36.2507,
    height: 36.5505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.07512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07512
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9075_10864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9075_10864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9075_10864",
    x1: 52.6278,
    y1: 2.09354,
    x2: 52.6278,
    y2: 90.6262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteResource);
export default __webpack_public_path__ + "static/media/deleteResource.72d7a3322a134fd424a2075b3d872390.svg";
export { ForwardRef as ReactComponent };